import { Button } from "@/shared/ui/button";
import { Plus, FileText, AlertTriangle, ClipboardCheck } from "lucide-react";

export function QuickActions() {
  return (
    <div className="bg-card rounded-xl shadow-card border border-border p-5">
      <h3 className="font-semibold text-foreground mb-4">Quick Actions</h3>
      <div className="grid grid-cols-2 gap-3">
        <Button variant="outline" className="flex-col h-auto py-4 hover:border-primary hover:bg-primary/5">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center mb-2">
            <Plus className="w-5 h-5 text-primary" />
          </div>
          <span className="text-sm">New Startup</span>
        </Button>
        <Button variant="outline" className="flex-col h-auto py-4 hover:border-primary hover:bg-primary/5">
          <div className="w-10 h-10 rounded-lg bg-success/10 flex items-center justify-center mb-2">
            <ClipboardCheck className="w-5 h-5 text-success" />
          </div>
          <span className="text-sm">Quality Check</span>
        </Button>
        <Button variant="outline" className="flex-col h-auto py-4 hover:border-destructive hover:bg-destructive/5">
          <div className="w-10 h-10 rounded-lg bg-destructive/10 flex items-center justify-center mb-2">
            <AlertTriangle className="w-5 h-5 text-destructive" />
          </div>
          <span className="text-sm">Log Defect</span>
        </Button>
        <Button variant="outline" className="flex-col h-auto py-4 hover:border-warning hover:bg-warning/5">
          <div className="w-10 h-10 rounded-lg bg-warning/10 flex items-center justify-center mb-2">
            <FileText className="w-5 h-5 text-warning" />
          </div>
          <span className="text-sm">Shift Report</span>
        </Button>
      </div>
    </div>
  );
}
